import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en/lang'
import tc from './tc/lang'

Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'tc'

const i18n = new VueI18n({
  locale,
  messages: { en, tc }
})

export default i18n



// WEBPACK FOOTER //
// ./src/constants/lang/i18n.js